import axios from '@/axios/axios'
import Cookies from '@/cookies/cookies'
import router from '@/router'

export default {
  loginRedirect: ({ getters }, route) => {
    if (route.fullPath.includes('/login')) {
      if (route.query && route.query.redirect) {
        router.replace(route.query.redirect)
      }
      else {
        if (getters.isOwiwi) {
          router.replace('/dashboard')
        } 
        else if(getters.isTurkish) {
          router.replace('/recruiters')
        }
        else {
          router.replace('/translate/dashboard')
        }
      }
    }
    else {
      router.replace(route.fullPath)
    }
  },

  getGuestToken: ({ commit, getters }) => {
    if (getters.getGuestToken) {
      axios.defaults.headers.common.Authorization = 'Bearer ' + getters.getGuestToken
      return
    }

    const postData = {
      username: process.env.VUE_APP_GUESTUSERNAME,
      password: process.env.VUE_APP_GUESTPASSWORD
    }

    return axios.post('authenticate', postData)
      .then(res => {
        const guestToken = res.data.id_token

        commit('setGuestToken', guestToken)
        axios.defaults.headers.common.Authorization = 'Bearer ' + guestToken
      })
  },

  login({ dispatch }, payload) {
    let loginUrl = 'authenticate-tool'

    return axios.post(loginUrl, payload.data)
      .then(async function(res) {
        const idToken = res.data.id_token

        Cookies.set('tool_token', idToken)
        axios.defaults.headers.common.Authorization = 'Bearer ' + idToken

        await dispatch('getAccountData', idToken)

        dispatch('loginRedirect', payload.route)
      })
      .catch(axios.throwError)
  },

  tryAutoLogin: async({ dispatch }, payload) => {
    const idToken = Cookies.get('tool_token')

    if (!idToken) {
      return false
    }

    axios.defaults.headers.common.Authorization = 'Bearer ' + idToken

    await dispatch('getAccountData', idToken)

    dispatch('loginRedirect', payload.route)
  },

  getDashboardStatistics: ({ commit, getters }) => {
    if (getters.isTranslator && !getters.isOwiwi) {
      return;
    }
    commit('setLoading', true)
    return axios.get('admin/tool/statistics')
      .then(res => {
        commit('updateDashboardStatistics', res.data)
        commit('setLoading', false)
      })
      .catch(err => {
        commit('setLoading', false)
        axios.throwError(err)
      })
  },

  getAccountData: ({ commit, dispatch }, payload) => {
    const idToken = payload.idToken

    return axios.get('account')
      .then(async res => {
        const userData = res.data
        userData.token = idToken

        await commit('updateUserData', userData)

        dispatch('getDashboardStatistics')
      })
      .catch(err => {
        dispatch('logout')
        axios.throwError(err)
      })
  },

  logout({ commit }, redirect) {
    Cookies.delete('tool_token')

    if (redirect) {
      window.location = redirect
    }
    else {
      window.location = '/login'
    }
  },

  getCandidates: ({ commit }, payload) => {
    const params = payload.params

    return axios.get('admin/tool/users', { params })
      .then(res => {
        commit('updateCandidatesPagination', {
          totalItems: res.data.totalElements,
          currentPage: params.page
        })

        commit('candidatesData', res.data.content)

        return res
      })
      .catch(axios.handleError)
  },

  getAssessments: ({ commit }, payload) => {
    const params = payload.params

    return axios.get('assessments', { params })
      .then(res => {
        // commit('updateCandidatesPagination', {
        //   totalItems: res.data.totalElements,
        //   currentPage: params.page
        // })

        // commit('candidatesData', res.data.content)

        return res
      })
      .catch(axios.handleError)
  },

  getOrigins: ({ commit, getters }) => {
    if (getters.origins.length) return

    return axios.get('origins')
      .then(res => {
        commit('origins', res.data)
      })
      .catch(axios.handleError)
  },

  getRecruiters: ({ commit }, payload) => {
    const params = payload.params

    return axios.get('admin/tool/recruiters', { params })
      .then(res => {
        commit('updateRecruitersPagination', {
          totalItems: res.data.totalElements,
          currentPage: params.page
        })

        commit('recruitersData', res.data.content)

        return res
      })
      .catch(axios.handleError)
  },

  getProfilePositionsDetailed: ({ commit }, payload) => {
    const params = payload.params

    return axios.get('admin/tool/recruiter/campaigns', { params })
      .then(res => {
        const data = res.data.content
        // commit('recruitersData', res.data.content)
        data.sort(function(a, b) {
          var keyA = new Date(a.createdDate);
          var keyB = new Date(b.createdDate);
          // Compare the 2 dates
          if (keyA > keyB) return -1;
          if (keyA < keyB) return 1;
          return 0;
        });
        return data
      })
      .catch(axios.handleError)
  },

  getUserActivityLog: ({ commit }, payload) => {
    const params = payload.params

    return axios.get(`activity-log/${params.profileId}`)
      .then(res => {
        const data = res.data
        data.sort(function(a, b) {
          var keyA = new Date(a.createdDate);
          var keyB = new Date(b.createdDate);
          // Compare the 2 dates
          if (keyA > keyB) return -1;
          if (keyA < keyB) return 1;
          return 0;
        });
        return data
      })
      .catch(axios.handleError)
  },
  

  getProfilePositions: ({ commit }, payload) => {
    return axios.get(`admin/tool/profile-positions-list/${payload.id}`)
      .then(res => {
        commit('profilePositionsData', res.data)

        return res
      })
      .catch(axios.handleError)
  },

  getMatchmakingPositions: ({ commit }, payload) => {
    const proxyURL = process.env.VUE_APP_PROXY

    const params = payload.params

    return axios.get(`${proxyURL}matchmaking-positions`, { params })
      .then(res => {
        commit('matchmakingPositionData', res.data)

        return res
      })
      .catch(axios.handleError)
  },
  postNotification: ({ commit }, payload) => {
    const data = payload

    return axios.post('/notifications', data)
      .then(res => {
        return res
      })
      .catch(axios.handleError)
  }
}
